import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Partners.css";
import PartnerHeader from "./PartnerHeader";
import PartnerHero from "./PartnerHero";
import PartnersPlan from "./PartnersPlan";
import PartnerStarted from "./PartnerStarted";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";

const Partners = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const partners = await axios.get(
      "https://staging-cms-main.ipurvey.com/partners"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([partners.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="partner_section">
          <PartnerHeader />
          <PartnerHero data={data[0]} />
          <PartnersPlan />
          <PartnerStarted />
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else return <Loader />;
};

export default Partners;
